import { customSeriesDefaultOptions, CustomSeriesOptions } from 'lightweight-charts'

export type FillSeriesOptions = CustomSeriesOptions & {
    fillGaps: boolean
}

export const defaultOptions: FillSeriesOptions = {
    ...customSeriesDefaultOptions,
    color: '#04998133',
    fillGaps: false,
    lastValueVisible: false
}
